import React, { Component } from "react";
import { connect } from "react-redux";
import { Field, reduxForm } from "redux-form";
import Button from "react-bootstrap-button-loader";
import { CopyToClipboard } from "react-copy-to-clipboard";
import { BaseComponent, LABEL_POSITION_TOP } from "BaseComponent";
import { COMMON_FAIL_MESSAGE, BASE_IMAGES_URL, DOMAIN_NAME } from "Constants";
import {
  publishedCourse,
  fetchAllUnpublishedCourses,
  fetchCurrentStep,
} from "CourseAction";
import { showError, showSuccess } from "ReduxErrorBar";
import LessonsDetails from "./course-chapters-details";
import LocaleStrings from "Languages";

class PublishCourse extends Component {
  constructor(props) {
    super(props);
    this.state = { loading: false, copied: false };
  }

  componentDidMount() {}

  onSubmitForm = (values) => {
    let { session, initialValues } = this.props;
    var courseid = initialValues.courseid;

    this.setState({ loading: true });
    this.props.publishedCourse(session, values, (res) => {
      this.setState({ loading: false });

      if (res.success) {
        if (values.ispublished) {
          this.props.showSuccess(
            LocaleStrings.course_publish_form_published_success
          );
          this.props.fetchCurrentStep("step_1");
        } else {
          this.props.showSuccess(
            LocaleStrings.course_publish_form_unpublished_success
          );
        }
        this.props.fetchAllUnpublishedCourses(session, courseid);
      } else {
        this.props.showError(COMMON_FAIL_MESSAGE);
      }
    });
  };

  copyUrl = () => {
    this.setState({ copied: true });

    setTimeout(() => {
      this.setState({ copied: false });
    }, 500);
  };

  render() {
    var {
      session,
      initialValues,
      showModal,
      handleSubmit,
      pristine,
      reset,
      submitting,
      invalid,
      eventDetails,
    } = this.props;
    let coverphoto = "";
    if (initialValues.coverimage && initialValues.coverimage != "") {
      coverphoto = `${BASE_IMAGES_URL}/${initialValues.coverimage}?api_key=${session.apiKey}&session_token=${session.sessionToken}`;
    }

    let seocode =
      eventDetails && eventDetails.seocode
        ? eventDetails.seocode
        : "not-found-seocode";
    let courseUrl = `http://${seocode}.${DOMAIN_NAME}/#/course-details/${initialValues.courseid}`;
    // http://platformdk.koachify.io/#/course-details/9863344

    return (
      <div>
        {initialValues.ispublished ? (
          <div className="promote-url-main_div mb-20">
            <h4 className="heading-para">
              {LocaleStrings.course_publish_text_course_promote_title}
            </h4>
            <p className="promote-para">
              {LocaleStrings.course_publish_text_course_published_subtitle}
            </p>
            <div className="row">
              <div className="col-md-10">
                <div className="url-display_copy-page">
                  <div className="url-text">{courseUrl}</div>
                  <CopyToClipboard text={courseUrl} onCopy={this.copyUrl}>
                    <div className="url-copy">
                      <i
                        className="fa fa-files-o i-custom-m"
                        aria-hidden="true"
                      ></i>
                      {LocaleStrings.button_copy}
                    </div>
                  </CopyToClipboard>
                </div>
                {this.state.copied ? (
                  <span style={{ color: "black", float: "right" }}>
                    {LocaleStrings.copied}.
                  </span>
                ) : null}
              </div>
              <div
                className="col-md-2"
                style={{ paddingLeft: 0, paddingTop: 2 }}
              >
                <a
                  href={courseUrl}
                  target="blank"
                  className="btn btn-custom-blue"
                >
                  <span aria-hidden="true">{LocaleStrings.button_visit}</span>
                </a>
              </div>
            </div>
          </div>
        ) : (
          ""
        )}

        {showModal && showModal.showModal ? (
          ""
        ) : (
          <div>
            <form onSubmit={handleSubmit(this.onSubmitForm)}>
              <div className="mb-10">
                <AddPublishForm {...this.props} />
              </div>

              <Button
                className="btn btn-custom-blue"
                loading={this.state.loading}
                disabled={pristine || invalid || submitting}
                type="submit"
              >
                {LocaleStrings.button_save}
              </Button>
            </form>
          </div>
        )}
      </div>
    );
  }
}

function mapStateToProps(state) {
  var initVals = {};
  if (
    state.allUnpublishedCourseList &&
    state.allUnpublishedCourseList.resource &&
    state.allUnpublishedCourseList.resource.length > 0
  ) {
    initVals = state.allUnpublishedCourseList.resource[0];
  }

  return {
    session: state.session,
    initialValues: initVals,
    allUnpublishedCourseList: state.allUnpublishedCourseList,
    showModal: state.courseModal,
    eventDetails: state.userEventDetails,
  };
}

function validate(values) {

}

export default connect(mapStateToProps, {
  publishedCourse,
  fetchAllUnpublishedCourses,
  fetchCurrentStep,
  showError,
  showSuccess,
})(
  reduxForm({
    validate,
    form: "PublishForm",
    enableReinitialize: true,
    keepDirtyOnReinitialize: true,
  })(PublishCourse)
);

class AddPublishForm extends BaseComponent {
  constructor(props) {
    super(props);
    this.state = {};
  }

  render() {
    return (
      <div className="basicform">
        <Field
          name="ispublished"
          label={LocaleStrings.course_publish_form_label_published}
          component={this.renderFieldCheckbox}
          type="checkbox"
        />
      </div>
    );
  }
}
